import { render } from "./WordpressMobile.vue?vue&type=template&id=d4032200"
import script from "./WordpressMobile.vue?vue&type=script&lang=js"
export * from "./WordpressMobile.vue?vue&type=script&lang=js"

import "./WordpressMobile.vue?vue&type=style&index=0&id=d4032200&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__